import { Splide } from '@splidejs/splide';
import '@splidejs/splide/css/core';

class ProductSlides {
  constructor(el) {
    this.dom = {el: el};
    this.dom.slider = this.dom.el.querySelector('.splide');

    this.slider = null;
    this.option = {
      // autoScroll: {
      //   speed: .5,
      // },
      // direction: this.direction,
      autoWidth: true,
      pagination: false,
      arrows: false,
      // padding: `min(${9 / 16}rem, ${9 / 375 * 100}vw)`,

      // pauseOnHover: true,
      // focus: 'center',
      type: 'loop',
      gap: `min(${9 / 16}rem, ${9 / 375 * 100}vw)`,
      rewind: true,
      loop: true,
      // perPage: 1,
      // autoWidth: true,
      speed: 1200,
      // drag: false,
      arrows: true,
      // arrowPath: false,
      // autoplay: true,
      // pauseOnHover: false,
      // interval: 4000,
      // lazyLoad: 'nearby',
      // drag: false,
      // items:PaginationItem[]
      mediaQuery: 'min',
      breakpoints: {
        768: {
          // type: 'loop',
          padding: `${236 / 1440 * 100}vw`,
          gap: `${95 / 1440 * 100}vw`,
          // focus: 'center',
        }
      }
    };

    this.init();
  }

  init() {
    this.slider = new Splide(this.dom.slider, this.option);
    this.slider.mount();
  }
}

export default ProductSlides